import { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { Link } from 'react-router-dom';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: 'How quickly can I withdraw my winnings?',
    answer: 'Withdrawal times vary by payment method. E-wallets like PayPal and Skrill typically process within 24 hours, while bank transfers can take 2-5 business days. Always check the casino\'s payout policy before depositing.'
  },
  {
    question: 'What are wagering requirements?',
    answer: 'Wagering requirements determine how many times you must bet your bonus amount before withdrawing. For example, a 35x wagering requirement on a £100 bonus means you need to wager £3,500 before cashing out.'
  },
  {
    question: 'Are UK casino bonuses worth it?',
    answer: 'Yes, if you understand the terms. Look for lower wagering requirements (under 40x), reasonable time limits, and games that contribute fully to wagering. Always read the full terms and conditions.'
  },
  {
    question: 'Do I need to verify my account?',
    answer: 'Yes, all UK-licensed casinos require KYC (Know Your Customer) verification. You\'ll need to provide ID, proof of address, and sometimes payment method verification before your first withdrawal.'
  }
];

export const FAQAccordion: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="glass-card p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-2xl font-bold text-primary-green">Frequently Asked Questions</h3>
        <Link
          to="/faq"
          className="text-sm text-primary-green hover:underline"
        >
          View All
        </Link>
      </div>
      <div className="space-y-2">
        {faqItems.map((item, index) => (
          <div key={index} className="border border-primary-green/20 rounded-lg overflow-hidden">
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full px-4 py-3 flex items-center justify-between text-left hover:bg-black/30 transition-colors"
            >
              <span className="font-medium text-white pr-4">{item.question}</span>
              <FiChevronDown
                className={`flex-shrink-0 text-primary-green transition-transform ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              />
            </button>
            {openIndex === index && (
              <div className="px-4 pb-3 text-sm text-gray-300">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

